// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2l141","content":"styles_content__xtmLG","checkbox":"styles_checkbox__1KoV0","checkboxLabel":"styles_checkboxLabel__1EHEg"};